import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/versapay/cart-creditcard-versapay.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";

export class CartCreditCardVersapayController extends Shared {
	constructor($cart, $sce) {
		super($cart, $sce);
		let $rootScope = resolve("$rootScope");
		let $stateParams = resolve("$stateParams");
		if ($stateParams.cartId) $cart.load($stateParams.cartId);
		let $ctrl = this;
		$ctrl.paymentMethod = {
			name: $ctrl.$cart.buyer,
			address: $ctrl.$cart.purchaser.address,
			address2: $ctrl.$cart.purchaser.address2,
			city: $ctrl.$cart.purchaser.city,
			state: $ctrl.$cart.purchaser.state,
			zip: $ctrl.$cart.purchaser.zip,
			country: $ctrl.$cart.purchaser.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.$cart.purchaser.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.$cart.purchaser.country,
		};
		$ctrl.bus = new ServiceBus;
		$ctrl.cartConfig = cartConfig;
		let retailerId = $ctrl.retailerId || $ctrl.$cart.retailerId;

		$ctrl.$cart.bus.send("Versapay/GetSession.json", {
		}).then(function(res) {
			if (res.data) {
				$ctrl.sessionId = res.data.id;
				var containerWidth = document.documentElement.clientWidth > 500 ? '500px' : '400px';
				var client = versapay.initClient($ctrl.sessionId);
				$ctrl.frameReadyPromise = client.initFrame(document.querySelector('#container'), '500px', containerWidth)
			}
		});
	}
	toggleSameAsCorporate() {
		let $ctrl = this;
		if ($ctrl.sameAsCorporate) {
			$ctrl.paymentMethod.address =
				$ctrl.$cart.purchaser.address || $ctrl.$cart.billingLocation.address;
			$ctrl.paymentMethod.address2 =
				$ctrl.$cart.purchaser.address2 || $ctrl.$cart.billingLocation.address2;
			$ctrl.paymentMethod.city =
				$ctrl.$cart.purchaser.city || $ctrl.$cart.billingLocation.city;
			$ctrl.paymentMethod.state =
				$ctrl.$cart.purchaser.state || $ctrl.$cart.billingLocation.state;
			$ctrl.paymentMethod.zip =
				$ctrl.$cart.purchaser.zip || $ctrl.$cart.billingLocation.zip;
			$ctrl.paymentMethod.country =
				$ctrl.$cart.purchaser.country || $ctrl.$cart.billingLocation.country;
		}
	}
}

export default {
	bindings: {
		retailerId: "@",
		returnUri: "@"
	},
	controller: CartCreditCardVersapayController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
